export interface RunnerRoute {
	pathname: string;
	search: string;
	hash: string;
}

export interface RunnerNavigationBridge {
	active: boolean;
	notify: () => void;
	stop: () => void;
}

export const removeTokenParameter = function (query: string): string {
	if (!query) return "";
	const prefix = query.charAt(0) === "?" ? "?" : "";
	const parameters = query.replace(/^\?/, "").split("&").filter(function (parameter) {
		if (!parameter) return false;
		const key = parameter.split("=")[0];
		try {
			return decodeURIComponent(key.replace(/\+/g, " ")).toLowerCase() !== "token";
		} catch (error) {
			return key.toLowerCase() !== "token";
		}
	});
	return parameters.length ? prefix + parameters.join("&") : "";
};

export const getRunnerRoute = function (location: Location): RunnerRoute {
	const hash = location.hash || "";
	const queryIndex = hash.indexOf("?");
	return {
		pathname: location.pathname || "/",
		search: removeTokenParameter(location.search || ""),
		hash: queryIndex > -1 ? hash.substring(0, queryIndex) + removeTokenParameter(hash.substring(queryIndex)) : hash
	};
};

const getParentOrigin = function (windowObject: Window): string {
	try {
		return new URL(windowObject.document.referrer).origin;
	} catch (error) {
		return "*";
	}
};

export const startRunnerNavigation = function (windowObject: Window): RunnerNavigationBridge {
	if (!windowObject || windowObject.parent === windowObject) {
		return { active: false, notify: function () {}, stop: function () {} };
	}
	let lastRoute: string;
	const parentOrigin = getParentOrigin(windowObject);
	const notify = function () {
		const route = getRunnerRoute(windowObject.location);
		const serializedRoute = JSON.stringify(route);
		if (serializedRoute === lastRoute) return;
		lastRoute = serializedRoute;
		windowObject.parent.postMessage({ type: "gennera-runner:navigate", route: route }, parentOrigin);
	};
	const stop = function () {
		windowObject.removeEventListener("hashchange", notify);
		windowObject.removeEventListener("popstate", notify);
	};
	windowObject.addEventListener("hashchange", notify);
	windowObject.addEventListener("popstate", notify);
	notify();
	return { active: true, notify: notify, stop: stop };
};
